
import * as _asset0 from "inline-asset:assets/galleries/ua-2021-11-17/L1000506-bw_5d2d8374be__20.jpg";
import * as _asset1 from "asset:assets/galleries/ua-2021-11-17/L1000506-bw_5d2d8374be__400.jpg";
import * as _asset2 from "asset:assets/galleries/ua-2021-11-17/L1000506-bw_5d2d8374be__800.jpg";
import * as _asset3 from "asset:assets/galleries/ua-2021-11-17/L1000506-bw_5d2d8374be__1600.jpg";


export default {
  id: "L1000506-bw",
  aspect: 1.512210200927357,
  alt: undefined,
  sources: [{
              url: _asset0.url,
              width: 20,
            },{
              url: _asset1.url,
              width: 400,
            },{
              url: _asset2.url,
              width: 800,
            },{
              url: _asset3.url,
              width: 1600,
            }],
};
        